import { render, staticRenderFns } from "./PetitionTable.vue?vue&type=template&id=62824424&scoped=true"
import script from "./PetitionTable.vue?vue&type=script&lang=ts"
export * from "./PetitionTable.vue?vue&type=script&lang=ts"
import style0 from "./PetitionTable.vue?vue&type=style&index=0&id=62824424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62824424",
  null
  
)

export default component.exports